

export default disallowConflictingImports;
import hasOwnProp from './hasOwnProp';
function disallowConflictingImports(imports) {
	var usedNames = {};

	imports.forEach(function (x) {
		if (x.passthrough) return;

		if (x.as) {
			checkName(x.as);
		} else {
			x.specifiers.forEach(checkSpecifier);
		}
	});

	function checkSpecifier(s) {
		checkName(s.as);
	}

	function checkName(name) {
		if (hasOwnProp.call(usedNames, name)) {
			throw new SyntaxError('Duplicated import (\'' + name + '\')');
		}

		usedNames[name] = true;
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/disallowConflictingImports.js.01-babel.map